export const initClipboard = () => {
  // Document CLICK
  document.addEventListener("click", onDocClick, false)
}

// ##########################
// ### Doc event handlers ###
const onDocClick = (e) => {
  if (e.target.classList.contains("copy-link")) {
    e.preventDefault()
    const url = e.target.getAttribute("data-clipboard-text")
    navigator.clipboard.writeText(url)
    e.target.classList.add("copied")
    setTimeout(() => {
      e.target.classList.remove("copied")
    }, 2000)
  }
}